import { EventEmitter } from "@angular/core";
import { QuantityUnitDto, ProductIdentifierDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";
import { ENVIRONMENT } from "projects/shared/lib/environment/environment";
import { firstValueFrom } from "rxjs";
import { IConfigurationService } from "shared/services/infrastructure/configuration/configuration-service.interface";

export class ProductAddToCartDialog {
  public title: string | undefined;
  public submitButtonLabel: string;
  public cancelButtonLabel: string;
  public productIdentifier: ProductIdentifierDto | undefined;
  public quantity: number;
  public minimumOrderAmount: number;
  public maximumOrderAmount: number;
  public orderUnit: QuantityUnitDto | undefined;
  public deliveryInformation: string | undefined;
  public modalSubmit: EventEmitter<any>;
  public modalCancel: EventEmitter<any>;

  constructor(configurationService: IConfigurationService, data?: Partial<ProductAddToCartDialog>) {
    this.title = $localize`:@@ProductAddToCartDialogDefaultTitle:Add to shopping cart`;
    this.submitButtonLabel = $localize`:@@ProductAddToCartDialogSubmitButtonDefaultLabel:Add`;
    this.cancelButtonLabel = $localize`:@@ProductAddToCartDialogCancelButtonDefaultLabel:Cancel`;
    this.minimumOrderAmount = 1;
    this.maximumOrderAmount = ENVIRONMENT.checkout.maximumOrderAmount;
    this.checkoutConfigurationCheckAsync(configurationService);
    this.quantity = this.minimumOrderAmount;
    this.modalSubmit = new EventEmitter();
    this.modalCancel = new EventEmitter();

    if (data) {
      Object.assign(this, data);
    }
  }

  private async checkoutConfigurationCheckAsync(configurationService: IConfigurationService) {
    let checkoutConfiguration = await firstValueFrom(configurationService.checkoutConfigurationGet());
    if (checkoutConfiguration.maximumOrderAmount != undefined) {
      this.maximumOrderAmount = checkoutConfiguration.maximumOrderAmount;
    }
  }
}
